
export const nullToEmpty = (input) => {

  if ((input === null) || (input === undefined)) {
    return "";
  }
  else {
    return input;
  }

};


export const nullToZero = (input) => {

  if ((input === null) || (input === undefined)) {
    return 0;
  }
  else {
    return input;
  }

};


export default nullToEmpty;